import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import 'vendor/jquery.fullscreen.js';
import FontAwesome from 'react-fontawesome';

const FullscreenButton = ({ 
  targetSelector = '#fullscreen',
  className = 'btn btn-round gray fullscreen-button',
  title = 'View Fullscreen',
  iconName = 'expand'
}) => {
  const handleFullscreen = (evt) => {
    evt.preventDefault();

    const element = document.querySelector(targetSelector);
    if (element) {
      $(element).fullScreen(true);
    }
  };

  return (
    <button
      className={className}
      onClick={handleFullscreen}
      title={title}
    >
      <FontAwesome name={iconName} />
    </button>
  );
};

FullscreenButton.propTypes = {
  targetSelector: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  iconName: PropTypes.string
};

export default FullscreenButton;